// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {buildFilterQueryString} from '../../shared/services/build-query';

const CityCellRenderer = props =>
    props.value ?
        <Link
            to={`/reimbursement-summary/details?query=${props.data.leadAccount}-${props.data.city}&leadAccount=${props.data.leadAccount}&city=${props.data.city}&leadAccountDisplayName=${encodeURIComponent(props.data.leadAccountDisplayName)}&postingDateFrom=${props.colDef.queryParams.postingDateFrom}&postingDateTo=${props.colDef.queryParams.postingDateTo}${buildFilterQueryString(props.colDef.unpaidFilter)}`}
        >
            {props.value}
        </Link> : null;

CityCellRenderer.displayName = 'CityCellRenderer';
CityCellRenderer.propTypes = {
    colDef: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    value: PropTypes.string
};

export default CityCellRenderer;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/components/city-cell-renderer.js